import {
  ColumnsVisibilityBadges,
  GroupedColumn,
} from "@src/shared/components/ColumnsVisibilityBadges/ColumnsVisibilityBadges";
import { RowData } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import styles from "./TableGroupHeader.module.css";

type TableGroupHeaderProps<TData extends RowData> = {
  hiddenColumns: GroupedColumn<TData>[];
  icon: React.ReactNode;
  label: React.ReactNode;
};

export function TableGroupHeader<TData extends RowData>({
  hiddenColumns,
  icon,
  label,
}: TableGroupHeaderProps<TData>) {
  const { t } = useTranslation("product");

  return (
    <div className={styles.TableGroupHeader}>
      <div className={styles.TableGroupHeaderContent}>
        <div className={styles.TableGroupHeaderIcon}>{icon}</div>
        {label}
      </div>

      <ColumnsVisibilityBadges
        align="center"
        className={styles.ColumnsVisibilityBadges}
        columns={hiddenColumns}
        extraColumnsLabel={(count) =>
          t("selection.batch.dataTable.extraColumnsLabel", { count })
        }
        nbDisplayedColumns={0}
      />
    </div>
  );
}
